
export default function LabelInputText({classError, type='text', name, value, onChange, placeHolder}) {
    return (
        <label className="LabelInputText">
            <input type={type} className={classError}  onChange={onChange} name={name} placeholder={placeHolder} value={value || ""}/>
        </label>
    );
}